import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { useCreditConfig } from '../../../contexts/CreditConfigContext';

const EnhanceButtonWithCredits = ({ isProcessing, processingProgress, onClick, disabled, scale }) => {
  const { t } = useI18n();
  const { getUpscalerCredits } = useCreditConfig();
  const cost = getUpscalerCredits(scale);

  return (
    <button 
      className={`enhance-button ${isProcessing ? 'processing' : ''}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        background: isProcessing 
          ? `linear-gradient(to right, #4CAF50 ${processingProgress}%, #666 ${processingProgress}%)`
          : '#4CAF50'
      }}
    >
      {isProcessing 
        ? `${t('imageUpscaler.processing')} ${Math.round(processingProgress)}% (${cost} ${t('credits.credits')})`
        : `${t('imageUpscaler.enhance')} (${cost} ${t('credits.credits')})`}
    </button>
  );
};

export default EnhanceButtonWithCredits;